import { Point } from '@ng-cloud/badger-core/models/interfaces/point';
import { Circle, FabricObject } from 'fabric';
import { MapObject } from './map-object';

export class MapCalloutObject extends MapObject {
  defaultOptions: any = {
    objectCaching: true,
    selectable: false,
    evented: false,
    lockMovementX: true,
    lockMovementY: true,
    lockScalingX: true,
    lockScalingY: true,
    lockRotation: true,
    hasControls: false,
    top: this.points[0].y,
    left: this.points[0].x,
    radius: 10,
    originX: 'center',
    originY: 'center',
    opacity: .2,
    fill: 'black'
  };

  constructor(public callout: any, private points: Point[], config?: any) {
    super(config);
  }

  protected build(): FabricObject {
    return new Circle(this.getOptions());
  };
}

